module.exports = __webpack_public_path__ + "2800ff461b7eda5e2fce797132f34902.otf";